import { useMemo } from 'react';

import { stringToHTML } from '@helpers/string';

interface IProps {
  summary: string;
  diseaseInformation?: string[];
  variantCalls?: string[];
}

const SingleGeneSummaryPane = ({ summary, diseaseInformation = [], variantCalls = [] }: IProps) => {
  const summarize = useMemo(() => (summary || '').split('\n'), [summary]);

  return (
    <div className='summary-pane result-details-tab-content'>
      {variantCalls.length > 0 && (
        <p className='summary-variant-call fw-bold'>
          {`${variantCalls.length > 1 ? 'Variant classifications' : 'Variant classification'}: ${variantCalls.join(', ')}`}
        </p>
      )}

      <div className='summarize'>
        {summarize.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>

      {diseaseInformation.map(info => (
        <div className='summary-detail-item' key={info}>
          {/* <p className='section-title'>{detail.title}</p> */}
          <div className='summary-detail-item-content'>
            {(info || '')
              .split('\n')
              .filter(str => str.trim())
              .map((info, index) => (
                <p key={index} dangerouslySetInnerHTML={{ __html: stringToHTML(info) }} />
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SingleGeneSummaryPane;
